<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/app/layouts/blank-layout.component.ts.BlankLayoutComponent.html